export default {
  name: 'PermissionMixin',
  computed: {
    currentPermissionAssociate() {
      return this.$store.state?.applicationState?.associate
    },
    /**
     * Computed property to access user permissions from Vuex store.
     * @returns {Array} - Array of user permissions.
     */
    userPermissions() {
      return this.currentPermissionAssociate?.permissions ?? []
    },

    hasAdminGroup() {
      return this.userPermissions.some(perm => perm.group === 'administrator')
    },

    hasSupervisorGroup() {
      return this.userPermissions.some(perm => perm.group === 'supervisor')
    },

    hasManagerScope() {
      return !!this.currentPermissionAssociate?.manager_scopes?.length
    }
  },
  methods: {
    /**
     * Checks if the user has a specific permission.
     * @param {string} permissionName - The name of the permission to check.
     * @returns {boolean} - Returns true if the user has the permission, otherwise false.
     */
    hasPermission(permissionName) {
      return this.userPermissions.some(perm => perm.name === permissionName)
    },

    /**
     * Checks if the user has ALL specified permissions.
     * @param {string[]} permissionNames - An array of permission names to check.
     * @returns {boolean} - Returns true if the user has all the specified permissions, otherwise false.
     */
    hasAllPermissions(permissionNames) {
      return permissionNames.every(name => this.hasPermission(name))
    },

    /**
     * Checks if the user has ANY of the specified permissions.
     * @param {string[]} permissionNames - An array of permission names to check.
     * @returns {boolean} - Returns true if the user has at least one of the specified permissions, otherwise false.
     */
    hasAnyPermission(permissionNames) {
      return permissionNames.some(name => this.hasPermission(name))
    },

    /**
     * Checks if the user has a specific permission within a certain group.
     * @param {string} permissionName - The name of the permission to check.
     * @param {string} groupName - The group name to match.
     * @returns {boolean} - Returns true if the user has the permission in the specified group, otherwise false.
     */
    hasPermissionByGroup(permissionName, groupName) {
      return this.userPermissions.some(perm => perm.name === permissionName && perm.group === groupName)
    },

    hasUncontrolledPermission(permissionName, info) {
      if (!this.currentPermissionAssociate) return false

      const current_associate =
        this.currentPermissionAssociate.id === info?.id ||
        this.currentPermissionAssociate.associate_number === info?.associate_number

      if (!current_associate) return this.hasPermission(permissionName)

      return this.userPermissions.some(perm => perm.name === permissionName && perm.scope === 'all')
    },

    hasAnyUncontrolledPermission(permissionNames, info) {
      if (!this.currentPermissionAssociate) return false

      const current_associate =
        this.currentPermissionAssociate.id === info?.id ||
        this.currentPermissionAssociate.associate_number === info?.associate_number

      if (!current_associate) return this.hasAnyPermission(permissionNames)

      return permissionNames.some(name => this.hasUncontrolledPermission(name))
    }
  }
}
